/**
 * Input type tel validation
 * @requires https://github.com/jackocnr/intl-tel-input
 */

export default (() => {
  const phoneInputs = document.querySelectorAll('[data-validate-phone]')

  phoneInputs.forEach((input) => {
    window.intlTelInput(input, {
      initialCountry: 'auto',
      separateDialCode: true,

      geoIpLookup: (success) => {
        fetch('https://ipapi.co/json')
          .then((res) => res.json())
          .then((data) => success((data.country_code || 'us').toLowerCase()))
          .catch(() => success('us'))
      },
    })
  })
})()
